// import PageTitle from "../../../components/PageTitle";
import Button from "../../../components/Button/Button";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import TabContext from "@mui/lab/TabContext";
import { ToastContainer, toast } from "react-toastify";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
// import BreadCrumb from "../../../components/BreadCrumb";
// import Inactive from "../component/Inactive";
// import Active from "../component/Active";
import PageTitle from "../../../components/PageTitle/PageTitle";
import ButtonCount from "../../../components/ButtonCount/ButtonCount";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import Modal from "../../../components/Modal/index";
import PageLoader from "../../../components/PageLoader/pageloader";
import Badge from "../../../components/Badge/Badge";
// import AllStatus from "../component/AllStatus";
import { httprequest } from "../../../data/api";
// import useStyles from "../styles";
import useWindowSize from "../../../hooks/useWindow";

const GET_ALL_ACCESS = "/admin/v1/access";
const ACCESS_CODES_ENDPOINT = "/admin/v1/access_code";

const AccessControl = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  // const classes = useStyles();

  const [searchResult, setSearchResult] = useState([]);
  const [value, setValue] = useState("");
  const [currentRow, setCurrentRow] = useState({});
  const [revokeModal, setRevokeModal] = useState(false);
  const [isAccessFetching, setIsAccessFetching] = useState(false);
  const [allaccessData, setAllAccessData] = useState([]);
  const [isRevoking, setIsRevoking] = useState(false);

  const handleRevokeModal = (row) => {
    setCurrentRow(row);
    setRevokeModal(true);
  };

  const handleCloseRevokeModal = () => {
    setCurrentRow({});
    setRevokeModal(false);
  };

  const width = useWindowSize();
  const mobile = width < 600;

  const getAllAccessCodes = () => {
    setIsAccessFetching(true);
    httprequest.get(`${GET_ALL_ACCESS}/${id}`).then((res) => {
      setIsAccessFetching(false);
      setAllAccessData(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      setIsAccessFetching(false);
      toast.error(err?.response?.data);
    });
  };

  const handleRevokeCode = () => {
    setIsRevoking(true);
    httprequest.patch(`${ACCESS_CODES_ENDPOINT}/${currentRow?.access_code}`).then((res) => {
      setIsRevoking(false);
      toast.success(res?.data?.message);
      getAllAccessCodes();
      handleCloseRevokeModal();
    }).catch((err) => {
      setIsRevoking(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === "active") {
      // setAllAccessData(allaccessData?.filter((access) => access?.status === "active"));
      setSearchResult(allaccessData?.filter((access) => access?.status === "active"));
    } else if (newValue === "inactive") {
      // setAllAccessData(allaccessData?.filter((access) => access?.status === "inactive"));
      setSearchResult(allaccessData?.filter((access) => access?.status !== "active"));
    } else {
      setSearchResult(allaccessData);
    }
  };

  useEffect(() => {
    getAllAccessCodes();
    setValue("all");
  }, []);

  // HAndle copy passcode
  const handleCopyPasscode = (row) => {
    setCurrentRow(row);
    navigator.clipboard.writeText(row?.access_code)
      .then(() => {
        toast.success(`${row?.access_code} has been copied`);
      })
      .catch((err) => {
        toast.error("Failed to copy access code", err);
      });
  };

  const columns = [
    {
      name: "Visitor's Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Visitor's Name</p>}
          {row?.visitor_name || "--/--"}
        </>
      )
    },
    {
      name: "Child Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Child Name</p>}
          {`${row?.student?.first_name} ${row?.student?.first_name}` || "--/--"}
        </>
      )
    },
    {
      name: "Access Type",
      selector: (row) => (<Badge status={row?.type} />)
    },
    {
      name: "Issued By",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Issued By</p>}
          {`${row?.issuer?.first_name} ${row?.issuer?.last_name}` || "--/--"}
        </>
      )
    },
    {
      name: "Access Code",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Access Code</p>}
          {row?.access_code || "--/--"}
        </>
      )
    },
    {
      name: "Expiry Date",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Expiry Date</p>}
          {row?.end_date?.substring(0, 10) || "N/A"}
        </>
      )
    },
    {
      name: "Status",
      center: "true",
      cell: (row) => (<Badge status={row?.status} />)
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          {/* <Link to={`/accesscontrol/codes/${row?.access_code}`} className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </Link> */}
          <button className="table-action-icon" onClick={() => handleCopyPasscode(row)}>
            <Icon icon="ph:copy" width="16" height="16" />
          </button>
          {row?.status === "active" ? (
            <button
              className="table-action-icon delete-icon" onClick={() => handleRevokeModal(row)}
            >
              <Icon icon="mdi:link-lock" />
            </button>
          ) :
            <button
              className="table-action-icon" disabled
            >
              <Icon icon="mdi:link-lock" />
            </button>}
        </div>
      )
    }
  ];

  useEffect(() => {
    // The data will be from the Email get api endpint
    setSearchResult(allaccessData);
  }, []);

  // --| Filter Shelf21 table using name, email and class
  const handleAccessControl = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = allaccessData?.filter((data) => valArray?.every(
      (word) => data?.visitor_name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                                      data?.email
                                        ?.toLowerCase()
                                        .includes(word.toLowerCase()) ||
                                      data?.student?.name
                                        ?.toLowerCase()
                                        .includes(word.toLowerCase()) ||
                                        data?.access_code
                                          ?.toLowerCase()
                                          .includes(word.toLowerCase()) ||
                                          data?.issuer?.name
                                            ?.toLowerCase()
                                            .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  // --| Filter Shelf21 table using name, email and class
  const handleSearchActive = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = allaccessData?.filter((access) => (access?.status === "active"))?.filter((data) => valArray?.every(
      (word) => data?.visitor_name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                                        data?.student?.name
                                          ?.toLowerCase()
                                          .includes(word.toLowerCase()) ||
                                        data?.issuer?.name
                                          ?.toLowerCase()
                                          .includes(word.toLowerCase()) ||
                                          data?.type
                                            ?.toLowerCase()
                                            .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  // const handleCloseLeaveModal = () => {
  //   setLeaveModal(false);
  // };

  return (
    <div>
      <PageTitle
        title="All Access Codes"
        subtitle="See a list of all the access codes that has been shared throughout the organisation."
        button={
          <div className="flex gap-10">
            <Button
              variant="primaryoutline"
              buttonSize="fluid"
              color="btnfontprimary"
              buttonName="Validate a code"
              onClick={() => navigate(`/schools/${id}/accesscontrol/validate`)}
            />
            <Button
              variant="primary"
              buttonSize="fluid"
              color="btndefault"
              onClick={() => navigate(`/schools/${id}/accesscontrol/create`)}
              buttonName="Create New Code"
            />
          </div>
        }
      />
      <div className="page-content">
        <TabContext value={value}>
          {searchResult.length > 0 && (
            <div className="tablist-container">
              <Tabs
                indicatorColor="none"
                className="overide-tablist"
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab label="All Access" value="all" />
                <Tab label="Active" value="active" />
                <Tab label="Inactive" value="inactive" />
              </Tabs>
            </div>
          )}

          <>
            <TabPanel value="all" className="tabpanel-overide">
              <div>
                {isAccessFetching ? (
                  <PageLoader />
                ) : (
                  <>
                    <div className="button-count-container">
                      <ButtonCount
                        title="All Access"
                        count={searchResult?.length}
                      />
                    </div>
                    <Table
                      data={searchResult}
                      columns={columns}
                      subHeader={true}
                      pagination
                      subHeaderComponent={
                        allaccessData.length > 0 ? (
                          <TableSearch placeholder="Search here..." searchTableFunc={handleAccessControl} />
                        ) : null
                      }
                    />
                  </>
                )}
                {/* Revoke Modal */}
                <Modal
                  title="Revoke Access Code"
                  subtitle={
                    <div>
                          Are you sure you want to Revoke{" "}
                      <span className="modal-name-highlight">
                        {currentRow?.access_code}
                      </span>
                          . from one of your Activities? Revoking it will stop
                          the code from working.`
                    </div>
                  }
                  modalContent={<></>}
                  modalFooter={
                    <>
                      <div className="flex gap-10">
                        <Button
                          variant="dangeroutline"
                          buttonSize="full"
                          color="btndanger"
                          buttonName="Cancel"
                          onClick={handleCloseRevokeModal}
                        />
                        <Button
                          variant="danger"
                          buttonName="Revoke Access Code"
                          buttonSize="full"
                          color="btndefault"
                          onClick={handleRevokeCode}
                          isLoading={isRevoking}
                        />
                      </div>
                    </>
                  }
                  isopen={revokeModal}
                  closeModal={handleCloseRevokeModal}
                />
              </div>
            </TabPanel>
            <TabPanel value="active" className="tabpanel-overide">
              {isAccessFetching ? (
                <PageLoader />
              ) : (
                <>
                  <div className="button-count-container">
                    <ButtonCount
                      title="Active Access"
                      count={searchResult?.length}
                    />
                  </div>
                  <Table
                    data={searchResult}
                    columns={columns}
                    subHeader={true}
                    pagination
                    subHeaderComponent={
                      searchResult.length > 0 ? (<TableSearch placeholder="Search active access here..." searchTableFunc={handleSearchActive} />
                      ) : null

                    }
                  />
                </>
              )}
            </TabPanel>
            <TabPanel value="inactive" className="tabpanel-overide">
              {isAccessFetching ? (
                <PageLoader />
              ) : (
                <>
                  <div className="button-count-container">
                    <ButtonCount
                      title="Inactive Access"
                      count={searchResult?.length}
                    />
                  </div>
                  <Table
                    data={searchResult}
                    columns={columns}
                    subHeader={true}
                    pagination
                    subHeaderComponent={
                      searchResult.length > 0 ? (
                        <TableSearch placeholder="Search here..." searchTableFunc={handleAccessControl} />
                      ) : null
                    }
                  />
                </>
              )}
            </TabPanel>
          </>
        </TabContext>
        {/* <Modal
              title="Need Help?"
              subtitle="Watch the Video Below"
              modalContent={
                <>
                  <div className="help_video">
                    <div className="help_video">
                      {videos?.map((video, index) => (
                        <div key={index} onClick={() => openVideoModal(video?.url)} className={classes.helpurl}>
                          <p>
                            {video?.label}
                          </p>
                          <Icon icon="ph:video" width="15" height="15" style={{ color: "black" }} />
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              }
              modalFooter={<></>}
              isopen={leaveModal}
              closeModal={handleCloseLeaveModal}
            /> */}
      </div>
      <ToastContainer />
    </div>
  );
};

export default AccessControl;
